export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11537.24855ad0.jpg";